import { SvgIcon, SvgIconProps } from '@mui/material';
import { white } from '@/lib/colours';

export function MailIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="mail_outline" clipPath="url(#clip0_3571_12527)">
          <path
            id="Vector"
            d="M20 4.00195H4C2.9 4.00195 2.01 4.90195 2.01 6.00195L2 18.002C2 19.102 2.9 20.002 4 20.002H20C21.1 20.002 22 19.102 22 18.002V6.00195C22 4.90195 21.1 4.00195 20 4.00195ZM19 18.002H5C4.45 18.002 4 17.552 4 17.002V8.00195L10.94 12.342C11.59 12.752 12.41 12.752 13.06 12.342L20 8.00195V17.002C20 17.552 19.55 18.002 19 18.002ZM12 11.002L4 6.00195H20L12 11.002Z"
            fill="currentcolor"
          />
        </g>
        <defs>
          <clipPath id="clip0_3571_12527">
            <rect
              width="24"
              height="24"
              fill={white[900]}
              transform="translate(0 0.00195312)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
